import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './Store/configureStore';
import { BrowserRouter as Router } from 'react-router-dom';
import './i18n';
import { msalInstance } from './authConfig';
import sw from './sw.js';
import AxiosClient from './Services/AxiosClient';
import history from './history';


//create redux store
const initialState = {};
const store = configureStore(initialState);

let service = AxiosClient.getInstance(store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <React.StrictMode>
        <App pca={msalInstance} />
      </React.StrictMode>
    </Router>
  </Provider>,
  document.getElementById('root')
);

sw();

reportWebVitals();
